import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import getData from "helpers/submitData"
import { loadingStatus } from "actions"
import FullTable from "components/FullTable"
import percentChange from "helpers/percentChange"
import helpers from "helpers/helpers"
import settings from 'settings'

class CommunityPerformance extends Component {
	constructor(props) {
		super(props)
		this.state = {
			rows: [],
			filtered: [],
			sorted: [],
			pulling: "sale_date",
			columns: [
				{
					Header: "Community",
					accessor: "community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Gross Sales",
					accessor: "gross",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.gross
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Previous Year Net",
					accessor: "prevNet",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.prevNet
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Net Sales",
					accessor: "net",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.net
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Projected",
					accessor: "projection",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.projection
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Cancellation Rate",
					accessor: "cancel_rate",
					Cell: (v) => {
						if (v.value) {
							if (Math.sign(v.value) == 1) {
								return `${v.value}%`
							} else if (Math.sign(v.value) == -1) {
								return `-${v.value}%`
							}
						}
						return "0%"
					},
					Footer: (props) => {
						return ""
					},
				},
				{
					Header: "Closings",
					accessor: "closings",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.closings
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Starts",
					accessor: "starts",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.starts
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Average Sale Price",
					accessor: "actual_avg_price",
					Cell: (v) => {
						if (v.value) {
							return `$${v.value.toLocaleString()}`
						}
						return "N/A"
					},
				},
				{
					Header: "Net/Projected Variance",
					accessor: "variance",
					pdfValue: "stringProjectedVariance",
					Cell: (v) => {
						if (v.value) {
							if (Math.sign(v.value) == 1) {
								return (
									<span className="darkGreen bold">
										+{v.value} / {v.original.variancePercentChange}%
									</span>
								)
							} else if (Math.sign(v.value) == -1) {
								return (
									<span className="red bold">
										{v.value} / {v.original.variancePercentChange}%
									</span>
								)
							}
						}
						return "0 / 0%"
					},
					Footer: (props, isPdf) => {
						let net = 0
						let projection = 0
						_.forEach(props.data, (v) => {
							if (v.net) net += v.net
							if (v.projection) projection += v.projection
						})
						let total = net - projection
						let percent = Math.round(percentChange(projection, net))
						if(isPdf) return `${total} / ${percent}%`
						if (Math.sign(total) == 1) {
							return (
								<span className="darkGreen bold">
									+{total} / +{percent}%
								</span>
							)
						} else if (Math.sign(total) == -1) {
							return (
								<span className="red bold">
									{total} / {percent}%
								</span>
							)
						} else {
							return 0
						}
					},
				},
				{
					Header: "YoY Variance",
					accessor: "yoy_variance",
					pdfValue: "stringYoYVariance",
					Cell: (v) => {
						if (Math.sign(v.value) == 1) {
							return (
								<span className="darkGreen bold">
									+{v.value} / {v.original.varianceYoY}%
								</span>
							)
						} else if (Math.sign(v.value) == -1) {
							return (
								<span className="red bold">
									{v.value} / {v.original.varianceYoY}%
								</span>
							)
						}
						return "0 / 0%"
					},
					Footer: (props, isPdf) => {
						let lastYear = 0
						let thisYear = 0
						_.forEach(props.data, (v) => {
							if (v.net) thisYear += v.net
							if (v.prevNet) lastYear += v.prevNet
						})
						let total = thisYear - lastYear
						let percent = Math.round(percentChange(lastYear, thisYear))
						if (isPdf) return `${total} / ${percent}%`
						if (Math.sign(total) == 1) {
							return (
								<span className="darkGreen bold">
									+{total} / +{percent}%
								</span>
							)
						} else if (Math.sign(total) == -1) {
							return (
								<span className="red bold">
									{total} / {percent}%
								</span>
							)
						} else {
							return 0
						}
					},
				},
				{
					Header: "Traffic",
					accessor: "traffic",
					filterMethod: (f, r) => helpers.tableText(f, r, "traffic"),
					Footer: (props) => helpers.tableTotals(props, "traffic", "0,0"),
				},
				{
					Header: "Previous Year Traffic",
					accessor: "prev_traffic",
					filterMethod: (f, r) => helpers.tableText(f, r, "prev_traffic"),
					Footer: (props) => helpers.tableTotals(props, "prev_traffic", "0,0"),
				},
			],
		}
		if(settings?.metroCommunityPerformance) {
			this.state.columns.unshift({
				Header: "Metro",
				accessor: "metro",
				filterMethod: (f, r) => helpers.tableText(f, r, "metro"),
			})
			this.state.columns.unshift({
				Header: "County",
				accessor: "county",
				filterMethod: (f, r) => helpers.tableText(f, r, "county"),
			})
		}
		this.state.originalColumns = _.cloneDeep(this.state.columns)
	}

	componentDidMount() {
		this.props.loadingStatus(true)
		this.pullData()
	}

	componentDidUpdate(prevProps) {
		if (!_.isEqual(prevProps, this.props)) {
			this.pullData()
		}
	}

	pullData = () => {
		getData("getCommunityPerformance", { dates: this.props.currentDates })
			.then((resp) => {
				// Determine if there's special develoeprs on the properties
				let customDev = false
				_.forEach(resp.data, v => {
					if(v.developer) customDev = true
				})
				let f = { rows: resp.data }
				if(customDev) {
					let cols = _.cloneDeep(this.state.originalColumns)
					cols.unshift({
						Header: "Developer",
						accessor: "developer",
						Cell: v => {
							if(typeof v?.value == 'string') return v.value.toUpperCase()
							return ""
						},
						filterMethod: (f, r) => helpers.tableText(f, r, "developer"),
					})
					f.columns = cols
				}
				this.setState(f, () => {
					//console.log(this.state)
				})
				this.props.loadingStatus(false)
			})
			.catch((e) => {
				console.log(e)
			})
	}

	buildTable = () => {
		let ret = []
		_.forEach(this.state.rows, (v,k) => {
			let property = _.find(this.props.payload.public.properties, {id: parseInt(k)})
			if(!property) return
			let metro = _.find(this.props.payload.public.metro, {id: property.metro_group})
			if(metro) v.metro = metro.name
			let county = _.find(this.props.payload.public.counties, {id: property.county})
			if(county) v.county = county.name
			v.community = property.name
			v.stringProjectedVariance = Math.sign(v.variance) == 1 ? `+${v.variance}` : `${v.variance}`
			v.stringYoYVariance = Math.sign(v.yoy_variance) == 1 ? `+${v.yoy_variance}` : `${v.yoy_variance}`
			ret.push(v)
		})
		return ret
	}

	createTable = () => {
		return (
			<div className="content">
				<FullTable
					data={this.buildTable()}
					columns={this.state.columns}
					classNames={`small`}
					pageSize={20}
					reInit={true}
					name="communityPerformance"
					title="Community Performance"
				/>
			</div>
		)
	}

	render() {
		return (
			<div className="sales">
				<div className="imageGroup">
					<Title title="Community Performance" />
					{this.createTable()}
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(CommunityPerformance)
